import React from 'react'
import 'styles/main.scss'
// import { trackRegFormOpen } from '../analytics/ga'

import Redirect from 'components/Redirect'
import AffiliateData from 'components/AffiliateData'
import SeoData from 'components/SeoData'
import AccessTokenProvider from 'providers/AccessToken'
import FormDataProvider from 'providers/FormData'
import DownloadAppLinks from 'components/DownloadAppLinks'
import FooterCopyContent from 'components/FooterCopyContent'
import FooterLinks from 'components/FooterLinks'
import Footer from 'components/Footer'

const Layout = props => {
  const {
    data: {
      airtable: {
        data: {
          title,
          description,
          metatags,
          matrimonialDb,
          footer_text: footerText,
        },
      },
    },
  } = props

  const {
    data: {
      airtable: {
        fields: { domainLogo, metaImage, androidAppStore, iphoneAppStore },
      },
    },
  } = props

  return (
    <AccessTokenProvider>
      <FormDataProvider>
        <Redirect />
        <AffiliateData />
        <SeoData
          title={title}
          description={description}
          keywords={metatags}
          domainLogo={domainLogo}
          metaImage={metaImage}
        />
        {props.children}
        <DownloadAppLinks
          altTitlePrefix={matrimonialDb}
          androidAppStore={androidAppStore}
          iphoneAppStore={iphoneAppStore}
        />
        <FooterCopyContent footerText={footerText} />
        <FooterLinks />
        <Footer />
      </FormDataProvider>
    </AccessTokenProvider>
  )
}

export default Layout
